import Vue from 'vue'

const methods = {
  /**
   * @return {{
   *     setSource: function(ol.source.Source): void,
   *     getSource: function(): ol.source.Source
   *   }|undefined}
   * @protected
   */
  getSourcesTarget () {
    throw new Error('Not implemented method')
  },
  /**
   * @return {ol.source.Source|undefined}
   */
  getSources () {
    return this._sources
  },
  /**
   * @returns {Object}
   * @protected
   */
  getServices () {
    const vm = this

    return {
      get sources () { return vm },
        get sourcesAdded() { return vm._sources_added },
        get sourcesLoaded() { return vm._sources_loaded }
    }
  },
  /**
   * @param {ol.source.Source|Vue|undefined} source
   * @return {void}
   */
  addSource (source) {
    this._sources.push(source)
    this._sources_added ++
  },
  increment (source) {
    this._sources_loaded ++
  }
}

export default {
  methods,
  created () {
    /**
     * @type {ol.source.Source|undefined}
     * @private
     */
    this._sources = []
  },
}



// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/containers/sources.js